import { Col, Form, Modal, Row } from 'antd';
import { RestInputContext } from 'components/form/RestInputContext';
import { zipObjectDeep } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import lodashValues from 'lodash/values';
import { useDispatch, useSelector } from '@redux';
import { editInvoiceInformation } from '@redux/orders/actions';
import { DynamicObjectType } from 'types/commons';
import crudSelectors from '@redux/crudSelectors';
import FormItem from 'components/form/FormItem';
import { validateRegex } from 'utils/validator';

const EditInvoiceModal = ({ visible, onCancel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const record = useSelector<DynamicObjectType>(
    (state) => state.orders.currentData,
  );
  const loading = useSelector(crudSelectors.orders.getLoadingCurrentRecord);

  const handleSubmit = (values) => {
    const payload = zipObjectDeep(Object.keys(values), lodashValues(values));

    dispatch(
      editInvoiceInformation({
        data: {
          id: record?.id,
          data: payload,
        },
        options: {},
      }),
    ).then(() => {
      onCancel();
      form.resetFields();
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={() => {
        form.submit();
      }}
      okButtonProps={{
        loading,
      }}
      title={t('orderDetail.editInvoiceInfo')}
    >
      <RestInputContext.Provider value={{ form }}>
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
          initialValues={record}
        >
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <div className="fw-500 text-[16px]">
                {t('orders.invoiceInformation')}
              </div>
            </Col>
            <Col span={24}>
              <FormItem
                name={['invoiceInfo', 'businessName']}
                label={t('invoiceInfo.businessName')}
              />
            </Col>
            <Col span={24}>
              <FormItem
                name={['invoiceInfo', 'taxCode']}
                label={t('invoiceInfo.taxCode')}
              />
            </Col>
            <Col span={24}>
              <FormItem
                name={['invoiceInfo', 'address']}
                label={t('invoiceInfo.address')}
              />
            </Col>
            <Col span={24}>
              <FormItem
                rules={[
                  {
                    pattern: validateRegex.phoneFull,
                    message: t('common.input.phone.validateMsg.invalid'),
                  },
                ]}
                name={['invoiceInfo', 'telephone']}
                label={t('invoiceInfo.telephone')}
              />
            </Col>
            <Col span={24}>
              <FormItem
                name={['invoiceInfo', 'email']}
                label={t('invoiceInfo.email')}
              />
            </Col>
          </Row>
        </Form>
      </RestInputContext.Provider>
    </Modal>
  );
};

export default EditInvoiceModal;
